import React from 'react';

const Step3Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-3">
        Se hai la bolletta elettrica sotto mano, riporta il costo che stai sostenendo al bimestre e/o il consumo annuale in kWh.
        </div>
    );
}

export default Step3Infos;